const Home = {
  init() {
    if ($('.home').length !== 1) return;

    if (typeof(tns) !== "undefined") {
      tns({
        container: '.quotes',
        items: 1,
        slideBy: 'page',
        autoplay: true,
        controls: false,
        nav: true
      });
    }

    // Safari occasionally does dodgy width calculations if you don't
    // give the browser a chance to catch up with rendering
    window.setTimeout(()=>{
      this.setUpInfinityScrolls('skills');
      this.setUpInfinityScrolls('careers');
    });
  },

  setUpInfinityScrolls(type) {
    const original = $(`.${type}-forward .content`);
    const clone = original.clone();
    clone.appendTo(`.${type}-forward`);
    this.animateBands(clone, original, 'forward');
    const original2 = $(`.${type}-backward .content`);
    const clone2 = original2.clone();
    clone2.appendTo(`.${type}-backward`);
    this.animateBands(clone2, original2, 'backward');
  },

  animateBands(offRight, centerStage, direction) {
    const widthRatio = centerStage.width() / $(window).width();
    const duration = 30000 * widthRatio; // The longer the banner, the more time it takes to display
    const width = centerStage.width() + 'px';
    const negativeWidth = '-' + width
    offRight.css('left', (direction === 'forward' ? negativeWidth : width));
    offRight.animate({left: '0'}, { duration: duration, easing: "linear"});
    centerStage.animate({left: (direction === 'forward' ? width : negativeWidth)},
                        {duration: duration,
                         easing: "linear",
                         complete: ()=> { this.animateBands(centerStage, offRight, direction) }});
  }
}

$(document).ready(()=> {
  Home.init();
});
